import "./waiting-cursor.scss";

export function setWaitCursor() {
    document.body.classList.add('busy-cursor');
}

export function clearWaitCursor() {
    document.body.classList.remove('busy-cursor');
}